import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {uploadPbssFile} from '../../../Store/Actions/pbssFiles';
import PbssFilesAddComponent from '../../../Components/AdminComponents/PbssFiles/PbssFilesAdd';

const PbssFilesAddContainer = () => {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (formData) => {
    setUploading(true);
    try {
      await dispatch(uploadPbssFile(formData));
    } finally {
      setUploading(false);
    }
  };

  return (
    <PbssFilesAddComponent onUpload={handleUpload} uploading={uploading} />
  );
};

export default PbssFilesAddContainer;
